import React from 'react';
import 'twin.macro';

interface IProps {
    className?: string;
}
export const Readonly = ({ className }: IProps): JSX.Element => {
    return <div className={className} tw="absolute w-full h-full left-0 top-0 z-10 opacity-20 bg-gray cursor-default"></div>;
};

export const ReadonlyLight = ({ className }: IProps): JSX.Element => {
    return <div className={className} tw="absolute w-full h-full left-0 top-0 z-10 opacity-50 cursor-default"></div>;
};
